import React, {Component, useCallback, useContext, useEffect, useRef, useState} from "react";
import {MainContextProvider} from "../../context/MainContext";
import ReactEditor from "../UI/ReactEditor/ReactEditor";
import InfiniteScroll from "react-infinite-scroll-component";
// @ts-ignore
import IntersectionObserver from "intersection-observer";
import customAxios from "../../service/api/interceptors";
import {ModalLoader} from "./ModalLoader/ModalLoader";
import {openPopupWidget} from "react-calendly";
import {toastifyError} from "../../service/toastify/toastify";



export const Test = () => {
    const { userData } = useContext(MainContextProvider);

    const bookCall = async () => {
        const { data: available } = await customAxios.get(`/call/list/available`)
        if (available.length > 0 && available.find((el: any) => String(el.type) === "2")) {
            const call = available.find((el: any) => String(el.type) === "2")
            openPopupWidget(
                { url: `https://calendly.com/legal-nodes-team/legal-discovery-session-onboarding?utm_source=${call.call_id}` })
        } else {
            const { data, status } = await customAxios.post(`/call/purchase`, {
                type: 2,
                count: 1,
                company_id: userData?.companies[0].id,
            })

            if (status === 200 && (data.length > 0) && data[0]?.id) {
                openPopupWidget(
                    { url: `https://calendly.com/legal-nodes-team/legal-discovery-session-onboarding?utm_source=${data.id}` })
            } else {
                toastifyError("Something went wrong. Contact technical support")
            }
        }
    }

    return (
        <div>
            <button onClick={bookCall}>Book</button>
        </div>
    )
}
